// action types for the item list
export const SET_CONTRACT_ITEM_LIST = "SET_CONTRACT_ITEM_LIST";
